module.exports = __webpack_public_path__ + "close-6dcfd7c55a059df9e07a.svg";